import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'creatorFormat',
    pure: true,
    standalone: false
})
export class CreatorFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(row: any, ...args: unknown[]): string {
    if (row !== null && row.creator) {
      return row.creator.firstName + ' ' + row.creator.lastName;
    } else {
      return this.translateService.instant('admin.module.price_lists.price_lists_grid.no_creator');
    }
  }
}